import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { startCase } from 'lodash';
import { Spinner } from 'components';
import styled from 'styled-components';
var Heading = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #8b8b8b;\n  color: #333333;\n  padding-bottom: 8px;\n"])));

function GMBSettings(props) {
  var _gmbAccountData$servi, _gmbAccountData$servi2;

  var account = props.account,
      isLoading = props.isLoading,
      gmbAccountData = props.gmbAccountData,
      formatOpenAndClose = props.formatOpenAndClose,
      periodsOnDay = props.periodsOnDay;
  var dow = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  var hours = dow.map(function (day) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: 235
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        "float": 'left',
        width: 100
      }
    }, startCase(day.toLowerCase())), /*#__PURE__*/React.createElement("ul", {
      style: {
        "float": 'left',
        margin: 0,
        padding: 0,
        listStyle: 'none'
      }
    }, function () {
      var ps = periodsOnDay(day);

      if (ps && ps.length > 0) {
        return ps.map(function (period) {
          return /*#__PURE__*/React.createElement("li", {
            key: "".concat(period.openTime).concat(period.closeTime)
          }, formatOpenAndClose(period.openTime, period.closeTime));
        });
      }

      return /*#__PURE__*/React.createElement("li", null, "Closed");
    }()));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center',
      marginTop: 12,
      fontWeight: 'bold'
    }
  }, "Loading Business Details..."), /*#__PURE__*/React.createElement(Spinner, {
    center: true
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      padding: 8
    }
  }, !!gmbAccountData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement("i", {
    style: {
      fontSize: 22
    },
    className: "fa fa-map-marker"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 18,
      paddingLeft: 8
    }
  }, "Service Areas")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      padding: 0
    }
  }, _toConsumableArray(((_gmbAccountData$servi = gmbAccountData.serviceArea) === null || _gmbAccountData$servi === void 0 ? void 0 : (_gmbAccountData$servi2 = _gmbAccountData$servi.places) === null || _gmbAccountData$servi2 === void 0 ? void 0 : _gmbAccountData$servi2.placeInfos) || []).map(function (p) {
    return /*#__PURE__*/React.createElement("li", {
      key: p.placeId,
      style: {
        paddingBottom: 4
      }
    }, p.name);
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement("i", {
    style: {
      fontSize: 22
    },
    className: "fa fa-clock-o"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 18,
      paddingLeft: 8
    }
  }, "Hours")), /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, hours)))));
}

export default GMBSettings;